import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import VPNProduct from './components/VPNProduct';
import Features from './components/Features';
import Contact from './components/Contact';
import Company from './components/Company';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <Hero />
      <VPNProduct />
      <Features />
      <Contact />
      <Company />
      <Footer />
    </div>
  );
}
